import { cn } from "@/lib/utils";
import { Button } from "../../../../../@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../../../../@/components/ui/popover";
import React, { useEffect, useState } from "react";
import { CaretSortIcon } from "@radix-ui/react-icons";
import {
  Command,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "../../../../../@/components/ui/command";
import { CheckIcon } from "lucide-react";
import { AppDispatch, RootState } from "store/store";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeadList, setSelectedTemplateLeadTab } from "store/leadTemplate";

export default function LeadSelectorComponent() {
  const dispatch: AppDispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<{
    lead_template_id: string;
    lead_template_name: string;
    lead_template_status_list: string[];
    fields: string[]
  } | null>(null);
  const [leadTemplates, setLeadTemplates] = useState<any[]>([]);

  const business = useSelector((state: RootState) => state.auth.business);
  useEffect(() => {
    if (business) {
      dispatch(fetchLeadList({ business })).then((response: any) => {
        const filteredTemplates = response.payload.filter(
          (lead: any) =>
            lead.lead_template_name.toLowerCase() !== "whatsapp orders"
        );
        setLeadTemplates(filteredTemplates);
        console.log("ai ai",filteredTemplates)
      });
      
    }
  }, [dispatch, business]);

  console.log("ddd", leadTemplates);

  useEffect(() => {
    if (leadTemplates.length > 0 && !selectedTemplate) {
      const templateStatusList = leadTemplates[0].lead_template_status_list || [];

      setSelectedTemplate({
        lead_template_id: leadTemplates[0].lead_template_id,
        lead_template_name: leadTemplates[0].lead_template_name,
        lead_template_status_list: templateStatusList,
        fields: leadTemplates[0].fields
      });

      dispatch(setSelectedTemplateLeadTab({
        templateId: leadTemplates[0].lead_template_id,
        templateName: leadTemplates[0].lead_template_name,
        statuses: templateStatusList,
        templateFields: leadTemplates[0].fields
      }));

    }
  }, [dispatch, leadTemplates, selectedTemplate]);

  const handleTemplateSelect = (lead: any) => {
    console.log("lljhello",lead.fields)
    const templateStatusList = lead.lead_template_status_list || [];
    
    setSelectedTemplate({
      lead_template_id: lead.lead_template_id,
      lead_template_name: lead.lead_template_name,
      lead_template_status_list: templateStatusList,
      fields: lead.fields
    });
    
    dispatch(setSelectedTemplateLeadTab({
      templateId: lead.lead_template_id,
      templateName: lead.lead_template_name,
      statuses: templateStatusList,
      templateFields: lead.fields,
    }));
    
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          aria-label="Select a team"
          className="w-[200px] justify-between h-8 text-sm"
        >
          {selectedTemplate
            ? selectedTemplate.lead_template_name
            : "Select a template"}
          <CaretSortIcon className="ml-auto h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-0">
        <Command>
          <CommandList>
            {leadTemplates.map((lead) => (
              <CommandItem
              key={lead.lead_template_id}
              onSelect={() => handleTemplateSelect(lead)}
              className="text-sm flex items-center space-x-2"
            >
              <CheckIcon
                className={cn(
                  "h-4 w-4",
                  selectedTemplate?.lead_template_name === lead.lead_template_name
                    ? "opacity-100"
                    : "opacity-0"
                )}
              />
              <span>{lead.lead_template_name}</span>
            </CommandItem>
            
            
            ))}
          </CommandList>
          <CommandSeparator />
        </Command>
      </PopoverContent>
    </Popover>
  );
}
